import { Alert, Button, Typography } from '@mui/material'
import { useNavigate } from 'react-router-dom'

export default function OnboardingLockBanner() {
  const navigate = useNavigate()

  return (
    <Alert
      severity="info"
      sx={{
        mb: 2,
        alignItems: 'center',
        '& .MuiAlert-message': {
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          flexWrap: 'wrap',
          gap: 1,
        },
      }}
    >
      <Typography variant="body2" sx={{ mr: 2 }}>
        You're still setting up this organisation. All data shown here can be
        changed during onboarding.
      </Typography>
      <Button
        variant="contained"
        size="small"
        disableRipple
        onClick={() => navigate('/onboarding')}
        sx={{ whiteSpace: 'nowrap', textTransform: 'none', width: '200px' }}
      >
        Resume Onboarding
      </Button>
    </Alert>
  )
}
